/**
 * 将 coupon-user 接口返回的 `mc`（voucherapi.md §6）转为当前语言文案。
 * 语言包中需存在与 `mc` 同名的根级 key。
 *
 * @param {(key: string, params?: object) => string} t
 * @param {string} [mc]
 * @param {string} [fallbackI18nKey] — 无 `mc` 或未配置词条时使用的 i18n key
 */
export function translateVoucherApiMc(t, mc, fallbackI18nKey) {
  const code = String(mc || "").trim();
  if (code) {
    const localized = t(code);
    if (String(localized) !== String(code)) return localized;
    return code;
  }
  return fallbackI18nKey ? t(fallbackI18nKey) : "";
}
